$(document).pjax("#pageBlock a.pjax", "#pageBlock");

$(document).on("pjax:start", function() { 
	$("#pageBlock").append(`
		<div id="pagePreLoader" class="loader-overlay">
	    	<div class="animsition-loading"></div>
		</div>
	`);
});

